import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, Fragment as _Fragment, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 d-flex align-items-center justify-content-start mb-1 mb-md-0" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "custom-search d-flex justify-content-end" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { class: "d-flex align-items-center" }
const _hoisted_12 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_13 = {
  key: 1,
  class: "text-info"
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = {
  key: 4,
  class: "text-nowrap"
}
const _hoisted_16 = { key: 5 }
const _hoisted_17 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_18 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_19 = { class: "custom-search" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-md-8" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_24 = { class: "card-head bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_25 = { class: "d-sm-flex align-items-center" }
const _hoisted_26 = { class: "d-flex align-items-center" }
const _hoisted_27 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_28 = {
  key: 0,
  class: "text-warning"
}
const _hoisted_29 = {
  key: 1,
  class: "text-info"
}
const _hoisted_30 = { key: 2 }
const _hoisted_31 = {
  key: 2,
  class: "text-nowrap"
}
const _hoisted_32 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.distribution.note_ref), 1),
        _cache[13] || (_cache[13] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("p", null, [
          _cache[9] || (_cache[9] = _createTextVNode(" Date de création : ", -1)),
          (_ctx.distribution.created_at)
            ? (_openBlock(), _createElementBlock("b", _hoisted_3, _toDisplayString(_ctx.getDate(_ctx.distribution.created_at)), 1))
            : _createCommentVNode("", true),
          _cache[10] || (_cache[10] = _createTextVNode(" | |", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.distribution.zone_name), 1),
          _cache[11] || (_cache[11] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.distribution.note_city), 1),
          _cache[12] || (_cache[12] = _createTextVNode(" | ", -1)),
          _createElementVNode("b", null, _toDisplayString(_ctx.distribution.note_delivery_name), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[18] || (_cache[18] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", null, "List des colis ajoutés")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[14] || (_cache[14] = _createElementVNode("label", null, "Voir", -1)),
            _createVNode(_component_v_select, {
              modelValue: _ctx.users2.per_page,
              "onUpdate:modelValue": [
                _cache[0] || (_cache[0] = ($event: any) => ((_ctx.users2.per_page) = $event)),
                _cache[1] || (_cache[1] = ($event: any) => (_ctx.getRows2()))
              ],
              options: [10, 25, 50, 100],
              clearable: false,
              class: "per-page-selector d-inline-block mx-50"
            }, null, 8, ["modelValue"]),
            _createElementVNode("label", null, _toDisplayString(_ctx.users2.total) + " entités", 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _withDirectives(_createElementVNode("input", {
                    placeholder: "Chercher",
                    type: "text",
                    onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getRows2())),
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.users2.searchTerm) = $event)),
                    class: "form-control"
                  }, null, 544), [
                    [_vModelText, _ctx.users2.searchTerm]
                  ])
                ])
              ])
            ])
          ])
        ]),
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns2,
          rows: _ctx.rows2,
          "search-options": {
          enabled: true,
          externalQuery: _ctx.users2.searchTerm,
        },
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
        },
          onSelectAll: _ctx.onSelectAll,
          onSelectedRowsChange: _ctx.selectionChanged
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[15] || (_cache[15] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [15]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_12, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[16] || (_cache[16] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_13, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[17] || (_cache[17] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_14, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'c_statut')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second)
                  .code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'actual_statut')
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                      (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                            style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second)
                  .code_color,
              })
                          }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                            style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                          }, _toDisplayString(props.row.s_name), 5))
                    ], 64))
                  : (props.column.field === 'price')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        _createElementVNode("b", null, _toDisplayString(props.row.price), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.$devis), 1)
                      ], 64))
                    : (props.column.field === 'updated_at')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.getDate(props.row.updated_at)), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "search-options", "onSelectAll", "onSelectedRowsChange"])
      ])
    ]),
    (_ctx.distribution.note_save == 0 && _ctx.auth.can('SCORE_BDIS'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _cache[22] || (_cache[22] = _createElementVNode("div", { class: "card-header" }, [
            _createElementVNode("h5", null, "Scan code suivi")
          ], -1)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("form", {
              onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.SearchColis && _ctx.SearchColis(...args)), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[19] || (_cache[19] = _createElementVNode("label", null, "Code Suivi :", -1)),
                      _withDirectives(_createElementVNode("input", {
                        placeholder: "Code Suivi",
                        type: "text",
                        id: "scanFocus",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.codeColis) = $event)),
                        class: "form-control"
                      }, null, 512), [
                        [_vModelText, _ctx.codeColis]
                      ])
                    ])
                  ]),
                  _cache[20] || (_cache[20] = _createElementVNode("div", { class: "col-md-4" }, [
                    _createElementVNode("button", {
                      class: "btn btn-success me-3 mb-3 mt-3",
                      type: "submit"
                    }, [
                      _createElementVNode("i", { class: "ph ph-scan" })
                    ])
                  ], -1)),
                  _cache[21] || (_cache[21] = _createElementVNode("div", { class: "col-12" }, [
                    _createElementVNode("hr")
                  ], -1))
                ])
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_23, [
      _cache[27] || (_cache[27] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h5", { class: "card-title" }, "Liste des colis enregistrés")
      ], -1)),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          (
            _ctx.auth.can('ADD_BDIS') &&
            _ctx.distribution.note_save == 0
          )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-danger fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                type: "button",
                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.removeNewColis && _ctx.removeNewColis(...args)))
              }, _cache[23] || (_cache[23] = [
                _createTextVNode(" Supprimer ", -1),
                _createElementVNode("i", { class: "flaticon-delete position-relative ms-5 fs-12" }, null, -1)
              ])))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getRows1())),
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.users1.searchTerm) = $event)),
            class: "form-control shadow-none text-black rounded-0",
            placeholder: "Chercher"
          }, null, 544), [
            [_vModelText, _ctx.users1.searchTerm]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_vue_good_table, {
          columns: _ctx.columns,
          rows: _ctx.rows1,
          "search-options": {
          enabled: true,
          externalQuery: _ctx.users1.searchTerm,
        },
          "select-options": {
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
        },
          onSelectAll: _ctx.onSelectAllColis,
          onSelectedRowsChange: _ctx.selectionChangedColis
        }, {
          emptystate: _withCtx(() => [
            _createVNode(_component_center, null, {
              default: _withCtx(() => _cache[24] || (_cache[24] = [
                _createTextVNode("Aucune entrées correspondants trouvés", -1)
              ])),
              _: 1,
              __: [24]
            })
          ]),
          "table-row": _withCtx((props) => [
            (props.column.field === 'code')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (props.row.replace == 1)
                    ? (_openBlock(), _createElementBlock("h6", _hoisted_28, [
                        _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                        _cache[25] || (_cache[25] = _createElementVNode("i", { class: "flaticon-refresh" }, null, -1))
                      ]))
                    : (props.row.partial == 1)
                      ? (_openBlock(), _createElementBlock("h6", _hoisted_29, [
                          _createTextVNode(_toDisplayString(props.row.code) + " ", 1),
                          _cache[26] || (_cache[26] = _createElementVNode("i", { class: "flaticon-corner-down-left" }, null, -1))
                        ]))
                      : (_openBlock(), _createElementBlock("h6", _hoisted_30, _toDisplayString(props.row.code), 1))
                ], 64))
              : (props.column.field === 'status')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                props.row.status == 'IN_PROGRESS' &&
                props.row.status_second &&
                _ctx.globalStore.globalHelper(props.row.status_second).name
              )
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({
                '--dynamic-bg': _ctx.globalStore.globalHelper(props.row.status_second)
                  .code_color,
              })
                        }, _toDisplayString(_ctx.globalStore.globalHelper(props.row.status_second).name), 5))
                      : (_openBlock(), _createElementBlock("div", {
                          key: 1,
                          class: "rounded-pill fs-13 badge text-bg-black custom-badge",
                          style: _normalizeStyle({ '--dynamic-bg': props.row.code_color })
                        }, _toDisplayString(props.row.s_name), 5))
                  ], 64))
                : (props.column.field === 'received_time')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(_ctx.getDate(props.row.received_time)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(props.formattedRow[props.column.field]), 1))
          ]),
          _: 1
        }, 8, ["columns", "rows", "search-options", "onSelectAll", "onSelectedRowsChange"])
      ])
    ])
  ], 64))
}